import React from 'react';
import { cn } from '../../lib/utils';
import { AlertCircle, Info, CheckCircle, AlertTriangle } from 'lucide-react';

export type CalloutVariant = 'info' | 'success' | 'warning' | 'error';

export interface CalloutProps {
  children: React.ReactNode;
  variant?: CalloutVariant;
  className?: string;
  icon?: boolean;
}

const icons = {
  info: Info,
  success: CheckCircle,
  warning: AlertTriangle,
  error: AlertCircle,
}

const styles = {
  info: 'border-blue-500/30 bg-blue-500/5 text-blue-700 dark:text-blue-300',
  success: 'border-emerald-500/30 bg-emerald-500/5 text-emerald-700 dark:text-emerald-300',
  warning: 'border-amber-500/30 bg-amber-500/5 text-amber-700 dark:text-amber-300',
  error: 'border-destructive/30 bg-destructive/5 text-destructive',
}

export function Callout({ children, variant = 'info', className, icon = true }: CalloutProps) {
  const Icon = icons[variant];
  return (
    <div className={cn('flex items-start gap-3 rounded-lg border px-4 py-3 text-sm', styles[variant], className)}>
      {icon && <Icon className="h-4 w-4 shrink-0 mt-0.5" />}
      <div className="flex-1 leading-relaxed">{children}</div>
    </div>
  );
}
